var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29007 5.99945L6.83007 2.45962C7.01632 2.27227 7.12086 2.01883 7.12086 1.75466C7.12086 1.49048 7.01632 1.23704 6.83007 1.04969C6.7371 0.955966 6.6265 0.881575 6.50464 0.830809C6.38278 0.780043 6.25208 0.753906 6.12007 0.753906C5.98805 0.753906 5.85735 0.780043 5.73549 0.830809C5.61363 0.881575 5.50303 0.955966 5.41007 1.04969L1.17007 5.28948C1.07634 5.38244 1.00194 5.49304 0.951175 5.61489C0.900406 5.73674 0.874268 5.86744 0.874268 5.99945C0.874268 6.13145 0.900406 6.26215 0.951175 6.38401C1.00194 6.50586 1.07634 6.61646 1.17007 6.70941L5.41007 10.9992C5.50351 11.0919 5.61432 11.1652 5.73616 11.215C5.858 11.2647 5.98846 11.29 6.12007 11.2892C6.25167 11.29 6.38213 11.2647 6.50397 11.215C6.62581 11.1652 6.73663 11.0919 6.83007 10.9992C7.01632 10.8119 7.12086 10.5584 7.12086 10.2942C7.12086 10.0301 7.01632 9.77663 6.83007 9.58927L3.29007 5.99945Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.b7aa5ca61616c8650cce1427d32db05a.svg";
export { ForwardRef as ReactComponent };